import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "rebass";
import { PreLoader } from "../loader/PreLoader.js";

function LoadingFrame({ order, catalog, agents, customer }) {
  const { loading: catalogLoading, loadingFilters: loadingCatalogueFilters } =
    useSelector((state) => state.yodaCatalogue);
  const ordersLoading = useSelector((state) => state.yodaOrders.loading);
  const agentsLoading = useSelector((state) => state.yodaAgent.loading);
  const customerLoading = useSelector((state) => state.yodaCustomer.loading);

  const [displayCondition, setDisplayCondition] = useState(false);

  useEffect(() => {
    let result = false;
    if (order && ordersLoading) {
      result = true;
    }
    if (catalog && (catalogLoading || loadingCatalogueFilters)) {
      result = true;
    }
    if (agents && agentsLoading) {
      result = true;
    }
    if (customer && customerLoading) {
      result = true;
    }

    setDisplayCondition(result);
  }, [
    catalogLoading,
    loadingCatalogueFilters,
    ordersLoading,
    agentsLoading,
    customerLoading,
    order,
    catalog,
    agents,
    customer,
  ]);

  return (
    <Box
      sx={{
        display: displayCondition ? "block" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,.5)",
        zIndex: 9999,
      }}
    >
      <Box
        justifyContent={"center"}
        display={"grid"}
        alignContent={"center"}
        sx={{ height: "100%" }}
      >
        <PreLoader />
      </Box>
    </Box>
  );
}

export { LoadingFrame };
